<div class="grid justify-content-center">
  <div class="text-center my-5 flex flex-column">
    <div class="text-color text-3xl font-semibold mb-2"> {{ onboardingDto?.formQuestionnaire?.uiName }}</div>
    <span class="text-color-secondary"> {{ onboardingDto?.formQuestionnaire?.uiDescription }}</span>
  </div>

  <div class="col-12 flex justify-content-center">
    @if (questionerForm) {

      <form [formGroup]="questionerForm">
        <div class="grid">
          @for (field of onboardingDto?.formQuestionnaire?.formFields; track field.id) {
            @if (field.access == FieldAccess.UPDATE) {
              <div class="col-12 flex flex-column justify-content-center gap-2 mb-3" [formGroup]="questionerForm">

                <div class="font-medium text-color-secondary">
                  {{ field.uiLabel }}
                </div>
                <div>

                  <!-- Input Text -->
                  @if (field.uiInputControl === 'input') {
                    <input
                      class="w-full"
                      pInputText
                      type="text"
                      [formControlName]="field.id">
                  }

                  <!-- select -->
                  @if (field.uiInputControl === 'singleOption') {
                    <div class="flex gap-2">
                      <p-selectButton
                        [options]="field.valueList"
                        [formControlName]="field.id"
                        optionLabel="label"
                        [allowEmpty]="false"
                        optionValue="key"></p-selectButton>
                    </div>
                  }

                  <!-- Textarea -->
                  @if (field.uiInputControl === 'text') {
                    <textarea
                      class="w-full"
                      [formControlName]="field.id"
                      rows="5"
                      pInputTextarea></textarea>
                  }

                </div>
              </div>
            }
          }
        </div>
      </form>
    }


  </div>
</div>
